module.exports = __webpack_public_path__ + "static/media/iconM8.c1faba44.svg";